export const essexWebDesignAreas = [
  "Chelmsford",
  "Brentwood",
  "Braintree",
  "Colchester",
  "Basildon",
  "Southend-on-Sea",
  "Maldon",
  "Rayleigh",
  "Witham",
  "Harlow",
  "Epping",
]

export const webDesignFaqs = [
  {
    question: "Do you provide web design services across Essex?",
    answer:
      "Yes. Web Wonderland is based in Chelmsford and works with businesses across Essex, including Brentwood, Braintree, Colchester, Basildon, Southend-on-Sea, Maldon, Rayleigh, Witham, Harlow and Epping. We also deliver projects for organisations elsewhere in the UK.",
  },
  {
    question: "How much does a business website cost?",
    answer:
      "The cost depends on the number and complexity of the pages, design requirements, content, ecommerce, integrations and any bespoke functionality. We begin by understanding the commercial requirement and then provide a scoped proposal with clear deliverables.",
  },
  {
    question: "How long does a web design and development project take?",
    answer:
      "Many business website projects take around six to twelve weeks, although the timing depends on scope, content readiness, integrations and the review process. We agree practical stages and responsibilities before development begins.",
  },
  {
    question: "Can you redesign our existing website?",
    answer:
      "Yes. We can review the structure, content, visual design, mobile experience, technical performance and conversion journey of an existing site before recommending a focused redesign or a more complete rebuild.",
  },
  {
    question: "Which website platforms do you work with?",
    answer:
      "WordPress and WooCommerce are central to much of our work, and we also develop bespoke website functionality and integrations where an off-the-shelf setup would create unnecessary limitations.",
  },
  {
    question: "Is SEO included with a new website?",
    answer:
      "Every build includes sound technical and on-page foundations such as semantic structure, indexable content, metadata planning, responsive layouts, internal links and performance-conscious implementation. Ongoing SEO and content growth can be scoped separately where required.",
  },
  {
    question: "Can you help with website content and copywriting?",
    answer:
      "Yes. We can help plan the sitemap, define the purpose of each page, shape service messaging, write or refine copy, and organise calls to action around the questions potential customers need answered.",
  },
  {
    question: "Will the website work properly on mobile devices?",
    answer:
      "Yes. We design responsively and test important page layouts, navigation, forms and interactions across appropriate screen sizes. Mobile clarity, accessibility and speed are considered throughout the project rather than added at the end.",
  },
  {
    question: "Do you provide hosting and support after launch?",
    answer:
      "Yes. We can provide suitable hosting, backups, updates, troubleshooting, maintenance and planned improvements after launch. The support arrangement is shaped around the website and its importance to your business.",
  },
  {
    question: "What happens after a new website goes live?",
    answer:
      "We check the launch, indexing and measurement setup, then review any agreed priorities for content, conversion, SEO, performance and ongoing development. A website should continue to improve as real customer and business evidence becomes available.",
  },
]
